import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { LogoMark } from '../LogoMark';

export default function Logo() {
  return (
    <Flex alignItems='center' justifyContent='center' height='100%'>
      <LogoMark />
      <Flex ml={10} alignContent='center' flexDirection='column'>
        <Text
          lineHeight='1'
          fontWeight='bold'
          fontSize={{ base: 15, md: 20 }}
          textTransform='uppercase'
        >
          Committed To Collaboration
        </Text>
        <Text textTransform='uppercase' textStyle='h6' mt={0} fontWeight={500}>
          IMF Annual Report 2023
        </Text>
      </Flex>
    </Flex>
  );
}
